import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ratio", "style"];
// src/aspect-ratio.tsx
import * as React from "react";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx } from "react/jsx-runtime";
var NAME = "AspectRatio";
var AspectRatio = React.forwardRef(function (props, forwardedRef) {
  var _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? 1 / 1 : _props$ratio,
      style = props.style,
      aspectRatioProps = _objectWithoutProperties(props, _excluded);

  return /* @__PURE__ */jsx("div", {
    style: {
      // ensures inner element is contained
      position: "relative",
      // ensures padding bottom trick maths works
      width: "100%",
      paddingBottom: "".concat(100 / ratio, "%")
    },
    "data-radix-aspect-ratio-wrapper": "",
    children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, aspectRatioProps), {}, {
      ref: forwardedRef,
      style: _objectSpread(_objectSpread({}, style), {}, {
        // ensures children expand in ratio
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      })
    }))
  });
});
AspectRatio.displayName = NAME;
var Root = AspectRatio;
export { AspectRatio, Root };